exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ app-search-location-trip.invalid-geocoding input {\n  color: red !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/riders/components/create/create.component.scss
// module id = 2096
// module chunks = 66